import AjaxHandler from "./ajax-handler";

class Pagination {
    constructor() {
        this.$ = jQuery;
        this.ajax = new AjaxHandler();
    }

    initPagination() {
        var current = 0;
        var page = 0;
        var href = "";

        var self = this;

        $(document).on("click", "ul.pagination .page-item", function (e) {
            var $elem = $(this);
            var $pageNum = $elem.find(".page-numbers");
            var $currentElem = $elem.parent().find(".page-item.active");

            if ($currentElem.length) {
                current = parseInt($currentElem.find(".page-numbers").html());
            }

            e.preventDefault();

            if (
                !$pageNum ||
                $pageNum.hasClass("current") ||
                $pageNum.hasClass(".dots")
            ) {
                return;
            }

            href = $pageNum.attr("href");
            page = parseInt($pageNum.html());

            if ($pageNum.hasClass("next")) {
                page = current + 1;
            } else if ($pageNum.hasClass("prev")) {
                page = current - 1;
            }

            let settings = $pageNum.closest("nav").data("settings");
            let title = document.getElementsByTagName("title")[0].innerHTML;

            // Update URL state to ajax link
            window.history.pushState("object or string", title, href);

            self.paginationHandler(page, href, settings);
        });
    }

    paginationHandler(page, href, settings) {
        let parsedSettings = JSON.parse(atob(settings));

        if (!parsedSettings) {
            return false;
        }

        let postsContainer = parsedSettings.posts_container;
        let paginationContainer = parsedSettings.pagination_container;

        $(parsedSettings.posts_container).LoadingOverlay("show", {
            imageClass: "jquery-loading-overlay-icon",
            image: ajax.templateUrl + "/assets/svg/loading.svg",
            imageResizeFactor: 1,
            zIndex: 800,
            background: "rgba(255, 255, 255, 0.5)"
        });

        $("ul.pagination")
            .css("opacity", 0.5)
            .css("pointer-events", "none");

        this.ajax
            .postRequest(
                { settings: settings, paged: page },
                "paginate_posts",
                postsContainer
            )
            .then(response => {
                $(parsedSettings.posts_container).LoadingOverlay("hide");

                if (response.data.posts_html) {
                    $(postsContainer).html(response.data.posts_html);
                    $(paginationContainer).html(response.data.pagination_html);

                    if (parsedSettings.scroll_to == "") {
                        parsedSettings.scroll_to = "#site-content";
                    }
                    if (parsedSettings.scroll_to) {
                        $([document.documentElement, document.body]).animate(
                            {
                                scrollTop: $(parsedSettings.scroll_to).offset()
                                    .top - 200
                            },
                            500
                        );
                    }
                }

                // console.log(response.data);
                if (response.data.title) {
                    document.title = response.data.title;
                }

                $("ul.pagination")
                    .css("opacity", 1)
                    .css("pointer-events", "default");
            });
    }
}

export default Pagination;
